import { render, staticRenderFns } from "./screenInformacionGeneral.vue?vue&type=template&id=2b0ad706"
import script from "./screenInformacionGeneral.vue?vue&type=script&lang=js"
export * from "./screenInformacionGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports